import React from "react";
import { Navigate } from "react-router-dom";

import { authStore } from "@/store/useAuthStore";

interface AuthRouteProps {
  children: React.ReactNode;
}

const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
  const isAuthenticated = authStore((state) => state.isAuthenticated());

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

export default AuthRoute;
